
$('.hmgbanner_slider').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	dots: false,
	infinite: true,
	speed: 1000,
	arrows: false,
	autoplay: true,
	autoplaySpeed: 1000,
	arrows: false,
	dots: false,
});
